import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const fetchQuestions = () => axios.get(`${API}/assessment/questions`).then((r) => r.data);

export const submitAssessment = (payload) =>
    axios.post(`${API}/assessment/submit`, payload).then((r) => r.data);

export const fetchReport = (id) =>
    axios.get(`${API}/assessment/report/${id}`).then((r) => r.data);
